import { PageTitle } from 'presentation/components/PageTitle';
import { CompanyForm } from './components/CompanyForm';

const CU00601Page = () => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-006-01-container"
        >
            <PageTitle title="基本情報の登録" />
            <section
                style={{
                    padding: '0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="corpo-form-container w-full">
                    <div className="section-wrapper">
                        <CompanyForm />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU00601Page;
